<template>
  <tsk-layout></tsk-layout>
</template>

<script>
import tskLayout from '@/components/layout/TKSLayout'

export default {
  name: 'Home',
  components: {
    tskLayout,
  },
  watch: {},
  computed: {},
  methods: {
    handleScroll() {
      console.log('스크롤 발생')
    },
  },
  async created() {},
}
</script>
